import { toastError } from '@utils/toastHelper';

interface ErrorConfig {
  title?: string;
  description?: string;
}

const handleApiError = (error: any, toThrow?: boolean, config?: ErrorConfig): Promise<unknown> => {
  const errorApplication = error && error.data && error.data.message;
  const errorFromServerSide = typeof error === 'string' ? error : undefined;
  const errorNetworkStatus = !window.navigator.onLine
    ? 'Você está offline: O acesso à nossa aplicação pode ser limitado'
    : 'Infelizmente tivemos algum problema não detectado';

  const errorMessage = errorApplication || errorFromServerSide || errorNetworkStatus;
  toastError((config && config.title) || 'Erro', (config && config.description) || errorMessage);

  if (toThrow) {
    throw new Error(errorMessage);
  }
  return new Promise(() => {
    throw new Error(errorMessage);
    // eslint-disable-next-line no-console
  }).catch(err => console.error(err));
};

export default handleApiError;
